import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_INTERAL_PREVIEW_REQUEST = 'Foundation/hire/FETCH_INTERAL_PREVIEW_REQUEST';
const FETCH_INTERAL_PREVIEW_SUCCESS = 'Foundation/hire/FETCH_INTERAL_PREVIEW_SUCCESS';
const FETCH_INTERAL_PREVIEW_FAIL = 'Foundation/hire/FETCH_INTERAL_PREVIEW_FAIL';

export default function reducer(state = {
  data: {},
  isListLoading: false,
}, action) {
  switch (action.type) {
    case FETCH_INTERAL_PREVIEW_REQUEST:
      return Object.assign({}, state, {
        isListLoading: true,
      });
    case FETCH_INTERAL_PREVIEW_SUCCESS:
      const originResponse = action.response.data;
      const educationArray = [];
      const workExperienceArray = [];
      originResponse.educationDatas.forEach((data) => {
        educationArray.push({
          academyName: data.academyName,
          attendanceStart: data.attendanceStart,
          attendanceEnd: data.attendanceEnd,
          academicDegree: data.academicDegreeText,
          academicDeptName: data.academicDeptName,
          completionStatus: data.completionStatusText,
        });
      });
      originResponse.workExperience.forEach((data) => {
        workExperienceArray.push({
          employeementStart: data.employmentStart,
          employeementEnd: data.employmentEnd,
          companyName: data.companyName,
          departmentName: data.departmentName,
          jobTitle: data.jobTitle,
        });
      });
      const formatResponse = {
        basicData: {
          birthDay: originResponse.basicInfo.birthday,
          personalPictureUrl: originResponse.personalPictureUrl,
          deptName: originResponse.employeeInfo.deptName,
          jobTitle: originResponse.employeeInfo.jobTitleName,
          mobileNumber: originResponse.contact.mobileNumber,
          jobGrade: originResponse.employeeInfo.jobGradeCode,
          lastName: originResponse.basicInfo.lastName,
          firstName: originResponse.basicInfo.firstName,
          englishName: originResponse.basicInfo.englishName,
          employeeNumber: originResponse.employeeInfo.employeeNumber,
        },
        certificaties: originResponse.certificaties || [],
        changeRecord: originResponse.changeRecord || [],
        educationDatas: educationArray,
        emergencyContacts: [{
          emergency: originResponse.contact.emergency,
          emergencyRelationship: originResponse.contact.emergencyRelationship,
          emergencyLandlineNumber: originResponse.contact.emergencyLandlineNumber,
          emergencyMobileNumber: originResponse.contact.emergencyMobileNumber,
        }],
        seniorityInfo: originResponse.seniorityInfoOfYeas ||
          {
            onBoard: null,
            companySeniorityOfYears: '',
            departmentSeniorityOfYears: '',
            jobGradeSeniorityOfYears: '',
            jobLevelSeniorityOfYears: '',
          },
        workExperience: workExperienceArray,
      };
      return Object.assign({}, state, {
        isListLoading: false,
        data: formatResponse,
      });
    case FETCH_INTERAL_PREVIEW_FAIL:
      return Object.assign({}, state, {
        isListLoading: true,
      });
    default:
      return state;
  }
}

export function fetchInternalPreview(id) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `PA/HireList/${id}/Hired`,
      method: 'GET',
      types: [
        FETCH_INTERAL_PREVIEW_REQUEST,
        FETCH_INTERAL_PREVIEW_SUCCESS,
        FETCH_INTERAL_PREVIEW_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Preview/Internal/reducers/index.js
 **/